import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Period, periodNameMap } from '../../interfaces/Period';

interface PeriodDropdownProps {
  label?: string;
  value?: Period;
  onChange: (newPeriod?: Period) => void;
  required?: boolean;
}

export const PeriodDropdown = (props: PeriodDropdownProps) => {
  return (
    <FormControl size='small' sx={{ width: 150 }}>
      {!!props.label && <InputLabel>{props.label}</InputLabel>}
      <Select
        label={props.label}
        value={props.value ?? ''}
        required={props.required}
        onChange={(e) =>
          props.onChange(
            e.target.value === '' ? undefined : (e.target.value as Period),
          )
        }
      >
        {!props.required && <MenuItem value='' />}
        {Object.entries(periodNameMap).map(([key, value]) => (
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
